export default __webpack_public_path__ + "static/media/logo.a06ef167.svg";